import { useNavigate } from 'react-router-dom';

export const useCommonNavigation = () => {
    const navigate = useNavigate();
    
    return {
        goToClients: () => navigate("/midwife/clients"),
        goToDashboard: () => navigate("/midwife"),
        goToCharting: (clientId) => navigate(`/charting/${clientId}`),
        goToAddClient: () => navigate("/midwife/clients/new"),
        goToClientChart: (clientId) => navigate(`/charting/${clientId}`),
        goBack: () => navigate(-1)
    };
}; 